import React from 'react';
import { View } from 'react-native';
import FormattedDate from 'src/components/10-atoms/date/FormattedDate';
import HTMLRenderer from 'src/components/10-atoms/form/inputs/editor/html/HTMLEditor/Renderer';
import ReadingColumn from 'src/components/10-atoms/layout/ReadingColumn';
import Row from 'src/components/10-atoms/layout/Row';
import BackdropLoader from 'src/components/10-atoms/loaders/BackdropLoader';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import AnswerUtils from 'src/modules/exam-preparation/graphql/answer/utils';
import TranslatedBadge from 'src/modules/translations/components/TranslatedBadge';
import useI18n from 'src/modules/translations/hooks/useI18n';
import isTranslatedDoc from 'src/modules/translations/utils/isTranslatedDoc';
import AnswerContributors from './AnswerContributors';
import CopyAnswer from './CopyAnswer';
import ImproveAnswer from './ImproveAnswer';
// RNW maps role="region" to <section>.
const visuallyHidden = {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
};
const AnswerItem = ({ answer, contributors, updateAnswerLoading, questionID, onEdit, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const currentAnswer = AnswerUtils.getCurrentAnswer(answer);
    const answerHTML = currentAnswer?.answer ?? '';
    const isTranslated = isTranslatedDoc(answer.translationInfo);
    const answerLabel = translate('Answer');
    return (React.createElement(ReadingColumn, { role: "region", accessibilityLabel: answerLabel },
        React.createElement(Typography, { role: "heading", "aria-level": 2, style: visuallyHidden }, answerLabel),
        React.createElement(Row, { ph: theme.spacing.page, xAxis: "space-between" },
            isTranslated ? React.createElement(TranslatedBadge, null) : React.createElement(View, null),
            React.createElement(FormattedDate, { mode: "relative", date: currentAnswer?.ctime ?? new Date(), variant: TypographyVariant.CAPTION, color: theme.palette.typography.secondary })),
        React.createElement(HTMLRenderer, { ph: theme.spacing.page, pv: theme.spacing.standard.sm, html: answerHTML }),
        React.createElement(AnswerContributors, { answer: answer, contributors: contributors, questionID: questionID }),
        React.createElement(ImproveAnswer, { answer: answer, onEdit: onEdit }),
        React.createElement(CopyAnswer, { answerHTML: answerHTML }),
        updateAnswerLoading && React.createElement(BackdropLoader, null)));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default AnswerItem;
